// src/components/ViewBatches.js
import React, { useEffect, useState } from 'react';
import { collection, getDocs }         from 'firebase/firestore';
import { db }                          from '../firebase';
import BatchDetails                    from './BatchDetails';

export default function ViewBatches() {
  const [batches, setBatches]             = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [loading, setLoading]             = useState(true);

  useEffect(() => {
    const fetchBatches = async () => {
      const snap = await getDocs(collection(db, 'batches'));
      setBatches(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    };
    fetchBatches();
  }, []);

  if (loading) return <p>Loading batches...</p>;

  if (selectedBatch) {
    return (
      <BatchDetails
        batch={selectedBatch}
        onBack={() => setSelectedBatch(null)}
      />
    );
  }

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">All Batches</h2>
      {batches.length === 0 ? (
        <p>No batches found.</p>
      ) : (
        <ul className="space-y-3">
          {batches.map(b => (
            <li
              key={b.id}
              className="p-4 border rounded flex justify-between items-center"
            >
              <div>
                <h3 className="font-medium text-lg">{b.batch_name}</h3>
                <p>Subject: {b.subject}</p>
              </div>
              <button
                onClick={() => setSelectedBatch(b)}
                className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                View Details
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
